import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import '../../styles/NotificationModal.css';

const NotificationModal = ({ 
  show, 
  handleClose, 
  onConfirm, 
  userEmail, 
  userPhone,
  loading = false 
}) => {
  const [notificationPreferences, setNotificationPreferences] = useState({
    email: false,
    whatsapp: false
  });

  const handleCheckboxChange = (type) => {
    setNotificationPreferences(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  const handleConfirm = () => {
    onConfirm(notificationPreferences);
  };

  const hasContactInfo = userEmail || userPhone;
  const canSendEmail = userEmail && notificationPreferences.email;
  const canSendWhatsApp = userPhone && notificationPreferences.whatsapp;

  return (
    <Modal show={show} onHide={handleClose} centered className="notification-modal">
      <Modal.Header closeButton className="notification-modal-header">
        <Modal.Title>
          <i className="fas fa-bell"></i>
          Confirmar Notificaciones
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="notification-modal-body">
        <div className="notification-info">
          <div className="info-icon">
            <i className="fas fa-info-circle"></i>
          </div>
          <div className="info-text">
            <h5>¿Deseas recibir notificaciones sobre tu denuncia?</h5>
            <p>Te enviaremos actualizaciones sobre el estado de tu reporte</p>
          </div>
        </div>

        {!hasContactInfo && (
          <div className="no-contact-warning">
            <i className="fas fa-exclamation-triangle"></i>
            <span>No tienes información de contacto registrada</span>
          </div>
        )}

        {hasContactInfo && (
          <div className="notification-options">
            <h6>Selecciona cómo quieres recibir las notificaciones:</h6>
            
            {userEmail && (
              <Form.Check 
                type="checkbox"
                id="email-notification"
                label={
                  <div className="checkbox-label">
                    <i className="fas fa-envelope"></i>
                    <span>Correo Electrónico</span>
                    <small>{userEmail}</small>
                  </div>
                }
                checked={notificationPreferences.email}
                onChange={() => handleCheckboxChange('email')}
                className="notification-checkbox"
              />
            )}

            {userPhone && (
              <Form.Check 
                type="checkbox"
                id="whatsapp-notification"
                label={
                  <div className="checkbox-label">
                    <i className="fab fa-whatsapp"></i>
                    <span>WhatsApp</span>
                    <small>{userPhone}</small>
                  </div>
                }
                checked={notificationPreferences.whatsapp}
                onChange={() => handleCheckboxChange('whatsapp')}
                className="notification-checkbox"
              />
            )}
          </div>
        )}

        <div className="notification-benefits">
          <h6>Beneficios de las notificaciones:</h6>
          <ul>
            <li>
              <i className="fas fa-check-circle"></i>
              <span>Recibirás tu número de ticket</span>
            </li>
            <li>
              <i className="fas fa-check-circle"></i>
              <span>Actualizaciones sobre el estado de tu denuncia</span>
            </li>
            <li>
              <i className="fas fa-check-circle"></i>
              <span>Comunicación directa con las autoridades</span>
            </li>
          </ul>
        </div>
      </Modal.Body>

      <Modal.Footer className="notification-modal-footer">
        <Button 
          variant="outline-secondary" 
          onClick={handleClose}
          className="cancel-btn"
        >
          <i className="fas fa-times"></i>
          Cancelar
        </Button>
        
        <Button 
          variant="primary" 
          onClick={handleConfirm}
          disabled={loading || !hasContactInfo || (!canSendEmail && !canSendWhatsApp)}
          className="confirm-btn"
        >
          {loading ? (
            <>
              <i className="fas fa-spinner fa-spin"></i>
              Procesando...
            </>
          ) : (
            <>
              <i className="fas fa-paper-plane"></i>
              Confirmar y Enviar
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NotificationModal;
